// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getFormQuestionAnswersForStudent } from '@lyon/utils/api/forms';

// ANCHOR GraphQL
import { Form_Question_Types_Enum as QuestionType } from '@lyon/graphql/types';

interface IProps {
  id: string;
  type: QuestionType;
}

export const FormQuestionAnswersForStudentData = createModel(({ id, type }: IProps) => {
  const isAllowed = type === 'multiple_choice' || type === 'checkbox_answer';

  const response = useSWR(
    (
      isAllowed
        ? `/forms-question/${id}/answers/student`
        : null
    ),
    () => (
      isAllowed
        ? getFormQuestionAnswersForStudent({ id })
        : undefined
    ),
  );

  return {
    ...response,
  };
}, {
  displayName: 'Models.FormQuestionAnswersForStudentData',
});

export const useFormQuestionAnswersForStudentData = createSelector(
  FormQuestionAnswersForStudentData,
  ({ data }) => data,
);
